import { render, staticRenderFns } from "./lottery-3d.vue?vue&type=template&id=42421ae3&scoped=true"
import script from "./lottery-3d.vue?vue&type=script&lang=js"
export * from "./lottery-3d.vue?vue&type=script&lang=js"
import style0 from "./lottery-3d.vue?vue&type=style&index=0&id=42421ae3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42421ae3",
  null
  
)

export default component.exports